/**
 * @generated SignedSource<<76022cb2d3fc3cba36512107a37cd180>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type MondayBoardSelectorQuery$variables = {};
export type MondayBoardSelectorQuery$data = {
  readonly viewer: {
    readonly integrations: {
      readonly monday: {
        readonly boards: ReadonlyArray<{
          readonly externalId: string;
          readonly id: string;
          readonly name: string;
        }>;
      } | null;
    };
  };
};
export type MondayBoardSelectorQuery = {
  response: MondayBoardSelectorQuery$data;
  variables: MondayBoardSelectorQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "MondayBoardNode",
  "kind": "LinkedField",
  "name": "boards",
  "plural": true,
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "externalId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "MondayBoardSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MondayUserNode",
                "kind": "LinkedField",
                "name": "monday",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "MondayBoardSelectorQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MondayUserNode",
                "kind": "LinkedField",
                "name": "monday",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v0/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9ca98f2a1efcb9a49b0b6c80828135d4",
    "id": null,
    "metadata": {},
    "name": "MondayBoardSelectorQuery",
    "operationKind": "query",
    "text": "query MondayBoardSelectorQuery {\n  viewer {\n    integrations {\n      monday {\n        boards {\n          id\n          name\n          externalId\n        }\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "aa90d00167205495b7d85bcd2735a81d";

export default node;
